import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'
import { rgba } from 'polished'
import theme from 'ui/styles/theme'

export default class ProductLandingVideo extends Component {
  state = {
    isMobile: false
  }

  componentDidMount() {
    this.detectMobile()

    window.addEventListener('resize', this.detectMobile)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.detectMobile)
  }

  detectMobile = () => {
    const width = window.innerWidth
    const isMobile = width <= theme.grid.breakpoints.md

    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile })
    }
  }
  
  render() {
    const {
      alignment,
      backgroundColor,
      title,
      description,
      buttonText,
      buttonLink,
      video,
      videoMobile
    } = this.props

    const { isMobile } = this.state

    return (
      <Wrapper>
        <TextContainer backgroundColor={backgroundColor}>
          <Container fluid style={{height: '100%'}}>
            <Row alignItems="stretch" style={{height: '100%'}}>
              <Col sm={4} smOffset={alignment === 'right' ? 8 : 0}>
                <TextContent>
                  <div>
                    <Title>{title}</Title>
                  </div>
                  <div>
                    <Text dangerouslySetInnerHTML={{ __html: description }} />
                    {buttonText && buttonLink && (
                      <Button to={getRelativeUrl(buttonLink)}>{buttonText}</Button>
                    )}
                  </div>
                </TextContent>
              </Col>
            </Row>
          </Container>
        </TextContainer>
        <VideoContainer>
          <Video src={isMobile ? videoMobile.sourceUrl : video.sourceUrl} autoPlay muted playsInline loop />
        </VideoContainer>
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.div`
  margin-bottom: 65px;
  position: relative;
`

const VideoContainer = styled.div`
  height: 0;
  padding-bottom: 56.25%;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  margin: 0;

  ${media.xs`
    margin: 0;
    padding-bottom: 100%;
  `}
`

const Video = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;
  object-fit: cover;
  
  ${media.xs`
    padding: 0;
  `}
`

const TextContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;

  ${media.xs`
    background: ${props => rgba(props.backgroundColor, 0.2)};
    position: relative;
  `}
`

const TextContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2em 0;
`

const Title = styled.h2`
  font-size: 40px;
  font-weight: 300;
  margin: 0;

  ${media.xs`
    margin-bottom: 0.65em;
  `}
`

const Text = styled.div`
  font-size: 18px;
  font-weight: 300;
`

const Button = styled(Link)`
  color: black;
  border: 1px solid black;
  border-radius: 2em;
  text-transform: uppercase;
  padding: 0.5em 1.5em;
  font-size: 11px;
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductLandingVideo/index.js